import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { getIndicator } from 'utils/common';

import { ProgressCircle } from './elements';
import EditBar from '../common/EditBar';
import { Container } from '../common/elements';

const deps = {
  currentGoal: state.challenge.info.computedCurrentGoal,
  indicator: state.challenge.campaign.indicator,
  totalUserStats:
    state.challenge.stats.total.profiles[state.appContainer.user.uid],
};

export function CurrentGoal({
  currentGoal,
  totalUserStats,
  indicator,
}: typeof deps & ConnectedProps): React.ReactElement {
  const totalUserSavings = getIndicator(totalUserStats, indicator);

  return (
    <Container>
      <EditBar />
      <ProgressCircle
        indicator={indicator}
        totalUserSavings={totalUserSavings}
        userGoal={currentGoal.goal.score / 1_000_000}
      />
    </Container>
  );
}
export default connect(deps, CurrentGoal);
